import React from 'react';
import PropTypes from 'prop-types';
import Button from 'Components/UI/Button';
import { NotificationManager } from 'react-notifications';
import { withHousehold } from 'Context/HouseholdContext';
import { uploadFileRaw } from 'Helpers/File';
import { generatePreview } from 'Components/PreviewApp';
import LoadingOverlay from 'Components/UI/LoadingOverlay/LoadingOverlay';
import moment from 'moment';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { stripInvalidFileNameCharacters } from 'Helpers/Formats';
import { FILE_UPLOAD_TYPES } from 'Consts/Queries';
import { BlueprintContext } from 'Context/BlueprintContext';
import { withStyles } from '@material-ui/core';
import { SwaggerlessContext } from 'Context/SwaggerlessContext';
import Checkbox from '../../UI/Checkbox';

const styles = () => ({
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  label: {
    margin: 0,
  },
});

class Subnav extends React.Component {
  constructor(props) {
    super(props);

    const { subnavRefs } = this.props;

    this.subnavRefs = subnavRefs;
    this.saveToFilestore = this.saveToFilestore.bind(this);

    this.state = {
      selected: 'overview',
      savingToFiles: false,
    };
  }

  getSelectedClass(s) {
    const { selected } = this.state;
    return selected === s ? 'on' : '';
  }

  async saveToFilestore(household) {
    const fileName = `${moment().format(
      'YYYYMMDD',
    )}_Blueprint_${stripInvalidFileNameCharacters(
      household.primaryClientLastName,
    ) || ''}.html`;
    const { getUser } = this.context;
    this.setState({ savingToFiles: true });
    // strip out the left nav before encoding the preview
    // NOTE: this regex is a hack and will break "send to client" if any extra divs are added inside of
    // the div being killed here
    const userResponse = await getUser();
    const uploadUrl = userResponse.data[0]?.relationships?.uploadFile?.links.related;
    const file = await generatePreview('blueprint', str => str.replace(/<div class="blueprint-subnav">.*?<\/div>.*?<\/div>/gi, ''));
    try {
      await uploadFileRaw(
        uploadUrl,
        [new File([file], fileName)],
        {
          householdId: household.id,
          folderId: household.folderId,
          type: FILE_UPLOAD_TYPES.secure,
        },
      );
    } catch (err) {
      displayErrorMessage(err, 'Failed to generate blueprint');
      this.setState({ savingToFiles: false });
      return;
    }
    this.setState({ savingToFiles: false });
    NotificationManager.success('Blueprint saved to files.');
  }

  scroll(e, ref, s) {
    e.preventDefault();

    this.setState({
      selected: s,
    });

    window.scrollTo({
      top: ref.offsetTop - 80,
      behavior: 'smooth',
    });
  }

  render() {
    const { household, classes } = this.props;
    const { savingToFiles } = this.state;

    return (
      <div className="blueprint-subnav">
        <ul>
          <li>
            <a
              href="#blueprint-overview"
              onClick={e => this.scroll(e, this.subnavRefs.overview, 'overview')
              }
              className={this.getSelectedClass('overview')}
            >
              Family Info
            </a>
          </li>
          <li>
            <a
              href="#blueprint-financial-summary"
              onClick={e => this.scroll(
                e,
                this.subnavRefs.financialSummary,
                'financialSummary',
              )
              }
              className={this.getSelectedClass('financialSummary')}
            >
              Financial Summary
            </a>
          </li>
          <li>
            <a
              href="#blueprint-strategies-recos"
              onClick={e => this.scroll(
                e,
                this.subnavRefs.strategiesRecos,
                'strategiesRecos',
              )
              }
              className={this.getSelectedClass('strategiesRecos')}
            >
              Strategies &amp; Recos
            </a>
          </li>
          <li>
            <a
              href="#blueprint-investment-assets"
              onClick={e => this.scroll(e, this.subnavRefs.clientProfile, 'clientProfile')
              }
              className={this.getSelectedClass('clientProfile')}
            >
              Client Profile
            </a>
          </li>
          <li>
            <a
              href="#blueprint-estate-planning"
              onClick={e => this.scroll(e, this.subnavRefs.estatePlanning, 'estatePlanning')
              }
              className={this.getSelectedClass('estatePlanning')}
            >
              Estate Planning
            </a>
          </li>
          <li>
            <a
              href="#blueprint-risk-management"
              onClick={e => this.scroll(e, this.subnavRefs.riskManagement, 'riskManagement')
              }
              className={this.getSelectedClass('riskManagement')}
            >
              Risk Management
            </a>
          </li>
          <li>
            <a
              href="#blueprint-footnotes"
              onClick={e => this.scroll(e, this.subnavRefs.footnotes, 'footnotes')
              }
              className={this.getSelectedClass('footnotes')}
            >
              Footnotes
            </a>
          </li>
        </ul>
        {savingToFiles && <LoadingOverlay />}
        <BlueprintContext.Consumer>
          {({ isReadOnly, changeToReadOnly, changeToEdit }) => (
            <div className={classes.buttons}>
              <Button
                color="secondary"
                variant="contained"
                disableElevation
                onClick={() => this.saveToFilestore(household)}
                disabled={!isReadOnly}
              >
                {'Share with client'}
              </Button>
              <Checkbox
                label="Read only?"
                checked={isReadOnly}
                classes={{
                  root: classes.label,
                }}
                onChange={(e) => {
                  if (e.target.checked) {
                    changeToReadOnly();
                  } else {
                    changeToEdit();
                  }
                }}
              />
            </div>
          )
          }
        </BlueprintContext.Consumer>
      </div>
    );
  }
}

Subnav.propTypes = {
  household: PropTypes.object.isRequired,
  subnavRefs: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

Subnav.contextType = SwaggerlessContext;

export default withHousehold(withStyles(styles)(Subnav));

// export { SubnavRefs }; // may need this

// export defaulult Subnav;
